// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MenuItems_wrapper__l0zcc","menuItem":"MenuItems_menuItem__gjI4m","divider":"MenuItems_divider__DWP6l","icon":"MenuItems_icon__daeBn"};